import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Box, Button,
  Container,
  CssBaseline,
  TextField
} from '@mui/material'
import { http } from 'interfaces'
import { useSessionContext } from 'session'
import { getShortUsername } from 'utils'

export const LoginPage: React.FC = () => {
  const [error, setError] = useState(false)
  const navigate = useNavigate()
  const { login, isAuthenticated, changeModuleName, changeUniqueId } = useSessionContext()

  useEffect(() => {
    changeModuleName('Editorial Tools')
    changeUniqueId('')
    const checkAuthentication = async (): Promise<void> => {
      isAuthenticated().then(authenticated => {
        if (authenticated) {
          navigate('/search')
        }
      }).catch(() => { navigate('/login') }
      )
    }
    void checkAuthentication()
  }, [isAuthenticated, navigate]
  )

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    setError(false)
    const params = new URLSearchParams()
    const data = new FormData(e.currentTarget)
    params.append('username', getShortUsername(data.get('username')?.toString() ?? ''))
    params.append('password', data.get('password')?.toString() ?? '')

    http
      .post('/login/', params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        login(response.data)
        navigate('/search')
      })
      .catch(() => {
        setError(true)
      })
  }

  return (
            <Container component="main" maxWidth="xs">
                <CssBaseline/>
                <Box
                    sx={{
                      marginTop: 8,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                >
                    <img width={200} src={require('../../images/KnowWho_From_Quorum_Logo_Horizontal_Blue_and_Red.png')}
                         alt="logo"/>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        {error && <Alert severity="error">Invalid Username or Password</Alert>}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Username"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            onFocus={() => { setError(false) }}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onFocus={() => { setError(false) }}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button>
                    </Box>
                </Box>
            </Container>
  )
}
